// src/components/Login.js
import React, { useState } from 'react';
import { auth } from '../firebaseConfig';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

import {
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  Container
} from '@mui/material';

import { useTenant } from '../contexts/TenantContext';
import { fetchUserDoc } from '../lib/firestoreUser';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const { tenantId } = useTenant(); // z. B. "meinfriseur" oder "demoTenant"

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      // 1) User mit E-Mail & Passwort einloggen
      const userCred = await signInWithEmailAndPassword(auth, email, password);
      const user = userCred.user;

      // 2) User-Dokument in der globalen "users"-Collection laden
      const userData = await fetchUserDoc(user.uid);
      if (!userData) {
        throw new Error('Kein passendes User-Dokument gefunden!');
      }

      // 3) Tenant-Abgleich
      if (userData.tenantId !== tenantId) {
        // Falls der Tenant nicht übereinstimmt → direkt Logout
        await signOut(auth);
        throw new Error(
          `Dieser Account gehört zu '${userData.tenantId}', nicht zu '${tenantId}'.`
        );
      }

      // 4) Optional: Rolle checken (admin, employee, etc.)
      // if (userData.role !== 'admin') {
      //   ...
      // }

      // 5) Erfolg: weiterleiten ins Dashboard
      navigate('/admin/dashboard');
    } catch (err) {
      console.error('Login-Fehler:', err);
      setError(err.message);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          padding: 4,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: 'background.paper'
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Login
        </Typography>

        {error && <Alert severity="error">{error}</Alert>}

        <form onSubmit={handleLogin} style={{ width: '100%' }}>
          <TextField
            label="Email"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            margin="normal"
          />
          <TextField
            label="Passwort"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            margin="normal"
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
          >
            Anmelden
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default Login;
